var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Map_2040369",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.88,
    height: 15,
    viewBox: "0 0 16.88 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M11.021,16.9V27.249l4.22.882v-.056c0-.544,0-.882.019-1.632,0-.75.019-1.088.019-1.632a.6.6,0,0,1,.6-.581.593.593,0,0,1,.6.6c0,.544,0,.882-.019,1.632,0,.75-.019,1.088-.019,1.632v.056l4.239-.882V16.9l-.338.169a.611.611,0,0,1-.807-.263.583.583,0,0,1,.263-.788l1.2-.6a.6.6,0,0,1,.731.15.605.605,0,0,1,.15.394V27.605a.742.742,0,0,1-.6.731l-5.27,1.107a.807.807,0,0,1-.3,0l-4.989-1.05a.3.3,0,0,1-.169.056l-4.82.938a.626.626,0,0,1-.713-.469A.141.141,0,0,1,5,28.824V17.008a.6.6,0,0,1,.469-.581l4.82-1.088a.651.651,0,0,1,.525.113L11.9,16a.578.578,0,0,1,.263.788.594.594,0,0,1-.806.263ZM6.2,28.093l3.62-.713V16.671l-3.62.806Z",
    transform: "translate(-5 -14.458)",
    fill: "#4795de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M49.07,14.92A1.107,1.107,0,1,1,50.2,13.813,1.1,1.1,0,0,1,49.07,14.92Zm0-4.22a3.142,3.142,0,0,0-3.17,3.113c.019,2.326,3.17,5.758,3.17,5.758s3.17-3.432,3.17-5.758A3.142,3.142,0,0,0,49.07,10.7Z",
    transform: "translate(-38.229 -10.7)",
    fill: "#4795de",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.3b9b969515bd88aff7de94ee99e2ab19.svg";
export { ForwardRef as ReactComponent };